import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import {
  Typography,
} from '@material-ui/core';
import classNames from 'classnames';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
  },
  status: {
    display: 'flex',
    flexFlow: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    flex: 1,
  },
  rowLeft: {
    flex: 1,
    fontWeight: theme.typography.fontWeightBold,
  },
  sectionHeader: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.accentGreen2,
  },
  rowRight: {
    flex: 1,
    fontWeight: theme.typography.fontWeightMedium,
  },
});

const TAB_SIZE_PX = 16;

const getRowArrayComponents = content => content.map(element => (<p style={{ marginBottom: '5px' }}>{element}</p>));

// eslint-disable-next-line react/prop-types
const RowComponent = ({ row, classes }) => {
  return (
    <div className={classes.row}>
      <div
        className={classes.rowLeft}
      >
        <Typography
          className={classNames({
            [classes.sectionHeader]: row.sectionHeader,
          })}
          style={{ paddingLeft: `${TAB_SIZE_PX * row.tabs}px` }}
          variant={row.sectionHeader ? 'h6' : 'body1'}
        >{row.left}
        </Typography>
      </div>
      {Array.isArray(row.right) ? (
        <Typography className={classes.rowRight}>
          {getRowArrayComponents(row.right)}
        </Typography>
      ) : (
        <Typography className={classes.rowRight}>
          {row.right}
        </Typography>
      )}
    </div>
  );
};

const View = ({
  classes, rows,
}) => {
  return (
    <Box className={classes.root}>
      {rows.map(row => <RowComponent row={row} classes={classes} />)}
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
};

export default withStyles(styles)(View);
